<template>
  <div
    :style="{
      width: `${size}px`,
      height: `${size}px`,
      'min-width': `${size}px`,
      'min-height': `${size}px`,
      '--border-width': `${borderWidth}px`
    }"
    class="profile-image-wrapper align-center justify-center rounded-circle"
    :class="{bordered}"
  >
    <div
      v-if="!user?.profile_picture_id"
      class="rounded-circle d-flex align-center justify-center"
      :style="{
        width: `${size}px`,
        'min-width': `${size}px`,
        height: `${size}px`,
        'min-height': `${size}px`,
        background: (user?.profile_picture_id || add) ? '#e0e0e0' : colorFromInitials,
      }"
    >
      <v-icon
        v-if="add"
        icon="add_a_photo"
        color="secondary"
        :size="40"
      />
      <div
        v-else
        class="text-uppercase initials"
        :style="{
          fontSize: `${parseFloat(size + '') / 2}px`,
        }"
      >
        {{ initials }}
      </div>
    </div>
    <v-img
      v-else
      :src="fileUrl(user?.profile_picture_id)"
      class="rounded-circle h-100 w-100 bg-white"
      cover
    />
  </div>
</template>
<script lang="ts">
import {fileUrl} from "@/plugins/file"

export default {
  name: 'ProfileImage',
  methods: {fileUrl},
  props: {
    user: {
      type: Object as any,
      default: null,
    },
    size: {
      type: [Number, String],
      default: 30,
    },
    add: Boolean,
    bordered: Boolean,
    borderWidth: {
      type: [Number, String],
      default: 2,
    },
  },
  computed: {
    initials() {
      return [
        this.user?.first_name,
        this.user?.last_name,
      ]
        .filter(Boolean)
        .map(n => n[0])
        .join('')
    },
    colorFromInitials() {
      const colors = [
        '#eebdbd',
        '#f1dbcb',
        '#eff1ce',
        '#c4e7be',
        '#b6e2e8',
        '#c2d2ee',
        '#c6c1ee',
        '#e3bde3',
      ]
      const charCodeSum = this.initials
        .split('')
        .reduce((acc, char) => acc + char.charCodeAt(0), 0)
      return colors[charCodeSum % colors.length]
    }
  },
}
</script>

<style lang="scss" scoped>
.profile-image-wrapper {
  flex-shrink: 0;
  display: flex;
  &.bordered {
    position: relative;
    //outline: var(--border-width) solid white;

    &::before {
      content: '';
      position: absolute;
      top: calc(-1 * var(--border-width));
      left: calc(-1 * var(--border-width));
      right: calc(-1 * var(--border-width));
      bottom: calc(-1 * var(--border-width));
      border: calc(var(--border-width) + 1px) solid white;
      border-radius: 50%;
    }
  }

  .initials {
    font-weight: 600;
    opacity: .5;
  }
}
</style>
